module.exports = __webpack_public_path__ + "media/images/application/template/logos/csta-logo-5c3a70d6fca66067122feca10ddb2a6b.png";